<template src="./DBAddUpdate.html"></template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("configuration");
import {notify, notifyApiError, notifyError} from "@/utils/notification-helper";
import { MESSAGES } from "@/utils/constants";
export default {
  data: function () {
    return {
      add: this.$route.params.add,
      DBData: {},
      expand: true,
      name: null,
      profile: null,
      connectionString: null,
    }
  },
  methods: {
    goToListPage: function () {
      this.$store.commit("configuration/cancel");
      this.$router.push({ name: "configuration" });
    },
    expandPanel() {
      let header = document.querySelectorAll("#panelbar .k-header");
      let element = document.querySelectorAll("#panelbar .k-content")[0];
      element.setAttribute("style", "display:block !important");
      header[0].addEventListener("click", () => {
        if (element.getAttribute("style") == "display: block;") {
          element.setAttribute("style", "display:none !important");
        }
      });
    },
    getDataOnload() {
      this.$store.dispatch("configuration/getInitialData", this.initialData)
      if(!this.$route.params.add) {
        this.title = "Update Configuration";
        this.deviceEditData = this.$store.getters["configuration/getEditDBDetail"];
        this.name= this.deviceEditData.microserviceName
        this.profile= this.getprofiles.find(i=>i.id===this.deviceEditData.configProfileID)
        this.connectionString= this.deviceEditData.connectionString
      }else {
        this.title = "Add Configuration";
      }
    },
    clearEntries: function () {
      this.name= null,
      this.profile= null,
      this.connectionString= null
    },
    addDBDetails: function () {
      if(this.name && this.profile && this.connectionString) {
        this.DBData= {
          ConfigProfileID: this.profile.id,
          MicroserviceName: this.name,
          ConnectionString: this.connectionString
        }
        if (this.add) {
          this.$store
          .dispatch("configuration/addDBDetail", this.DBData)
          .then((data) => {
            console.log("Data : ",data)
            // if (data.success) {
              notify(MESSAGES.RECORD_CREATE_SUCCESS);
              this.goToListPage();
              this.clearEntries();
            // } else {
            //   notifyWarn(data.message);
            // }
          })
          .catch((err) => {
            try {
              notifyError(err.response.data.message);
            } catch (error) {
              notifyApiError({ message: "Something went wrong" });
            }
          });
        } else {
          this.$store
          .dispatch("configuration/updateDBDetail", this.DBData)
          .then((data) => {
            console.log("Data : ",data)
            // if(data.status) {
              notify(MESSAGES.CHANGES_SAVE_SUCCESS);
              this.goToListPage();
              this.clearEntries();
            // }else {
            //   notifyWarn(data.message);
            // }
          }).catch(notifyApiError);
        }
      }
    }
  },
  computed: {
    ...mapState(["initialData"]),
    getprofiles() {
      return this.initialData.profiles;
    },
  },
  mounted() {
    this.expandPanel();
    this.getDataOnload();
    // this.getDataOnload()
  },


}
</script>

<style lang="scss" scoped>
@import url("https://unpkg.com/vue-multiselect@2.1.0/dist/vue-multiselect.min.css");
@media only screen and (max-width: 768px) {
  .k-form,
  .k-form-inline {
    font-size: 1rem;
    line-height: 1.5;
    padding: 1rem !important;
  }
  .page-header .title-text {
    font-size: 12px;
    margin-left: 10px;
  }
  .mobile_side_lbl {
    width: 70% !important;
  }
  .mobile_side_btn {
    display: flex;
  }
  .driver_header_mobile {
    flex-direction: row !important;
    overflow-x: auto;
    padding: 10px 10px 10px 10px;
  }
}
.multiselect__tags {
  display: block;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 12px;
}
</style>